import React from "react";
import PropTypes from "prop-types";
import { PAGINATION_TEXT, PAGINATION_CONFIG } from "./constants.js";
import { getPageRange, getItemRange } from "./utils.js";
import "./styles.scss";

export default function Pagination({
  totalPages,
  currentPage,
  onPageChange,
  rowsPerPage,
  onRowsPerPageChange,
  totalItems,
}) {
  const { MAX_VISIBLE_PAGES, ROWS_PER_PAGE_OPTIONS, PREV_SYMBOL, NEXT_SYMBOL, ELLIPSIS } = PAGINATION_CONFIG;

  const { startPage, endPage, pageNumbers } = getPageRange(currentPage, totalPages, MAX_VISIBLE_PAGES);

  const { startItem, endItem } = getItemRange(currentPage, rowsPerPage, totalItems);

  return (
    <div className="pagination">
      {/* Info */}
      <div className="pagination__info">
        {totalItems ? (
          <>
            {PAGINATION_TEXT.SHOWING} {startItem} {PAGINATION_TEXT.TO} {endItem} {PAGINATION_TEXT.OF} {totalItems}{" "}
            {PAGINATION_TEXT.MESSAGES}
          </>
        ) : (
          PAGINATION_TEXT.NO_MESSAGES
        )}
      </div>

      <div className="pagination__controls">
        {/* Rows per page */}
        <div className="pagination__rows">
          <label htmlFor="rowsPerPage">{PAGINATION_TEXT.ROWS_PER_PAGE}</label>
          <select id="rowsPerPage" value={rowsPerPage} onChange={e => onRowsPerPageChange(Number(e.target.value))}>
            {ROWS_PER_PAGE_OPTIONS.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {/* Previous */}
        <button
          className="pagination__button"
          disabled={currentPage === 0}
          onClick={() => onPageChange(Math.max(0, currentPage - 1))}
        >
          {PREV_SYMBOL}
        </button>

        {startPage > 0 && <span className="pagination__ellipsis">{ELLIPSIS}</span>}

        {/* Page numbers */}
        {pageNumbers.map(page => (
          <button
            key={page}
            className={`pagination__button ${currentPage === page - 1 ? "pagination__button--active" : ""}`}
            onClick={() => onPageChange(page - 1)}
          >
            {page}
          </button>
        ))}

        {endPage < totalPages && <span className="pagination__ellipsis">{ELLIPSIS}</span>}

        {/* Next */}
        <button
          className="pagination__button"
          disabled={currentPage === totalPages - 1}
          onClick={() => onPageChange(Math.min(totalPages - 1, currentPage + 1))}
        >
          {NEXT_SYMBOL}
        </button>
      </div>
    </div>
  );
}

Pagination.propTypes = {
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
};
